import store_rendez_vous from '@/store/mods/clinique/rendez_vous'
import PriseRendezVous from '@/components/rendez-vous/prise-rendez-vous'
import IndicateursRendezVous from '@/components/rendez-vous/indicateurs-rendez-vous'   // RDV-005
import FixerHeureRendezVous from '@/components/rendez-vous/fixer-heure-rendez-vous'   // RDV-006
import MenuActions from '@/components/menu-actions'   // menu « ⋮ » des tableaux compacts
import { aujourdhui, jour_valide, plage_periode, deplacer_periode, libelle_periode, jour_lisible, mois_lisible, jour_instant, instant_lisible, jour_abrege, jour_rdv, date_rdv_lisible, heure_lisible, est_heure_a_fixer, heure_a_fixer_possible, ton_statut, message_erreur, patient_bon_rendez_vous, type_bon_rendez_vous, contexte_bon_rendez_vous, PERIODES } from '@/utils/rendez-vous'
import { telephone_affiche, titre_telephone } from '@/utils/telephone'   // C9 : téléphone du patient, sinon de l'accompagnant

// RDV-002 : agenda des rendez-vous à l'Accueil et à la Caisse — tous les médecins ou un seul, états et recherche ;
// honoré / absent le jour même ou après, annulation motivée, reprogrammation. Les journées sont découpées par la
// Clinique dans le fuseau de l'établissement ; le poste ne fait qu'afficher.
// RDV-006 : un rendez-vous donné sans heure par le médecin n'affiche jamais 00:00 ; tant que son jour n'est pas passé,
// l'Accueil fixe l'heure depuis la ligne (lien « Fixer l'heure » de la colonne Heure).
// C8 : période Jour, Semaine (défaut, semaine d'aujourd'hui) ou Mois autour d'une date d'ancrage, envoyée à la Clinique
// (« periode » + « date ») ; la colonne Date situe chaque ligne. Même composant pour la page /rendez-vous et
// pour la carte du tableau de bord (mode_carte). Tant que la période affichée contient aujourd'hui, aucune date n'est
// envoyée : la Clinique ancre la période sur son aujourd'hui (fuseau de l'établissement), pas sur celui du poste.
// Un clic sur Jour, Semaine ou Mois (même la vue active) revient à la période d'aujourd'hui ; les flèches avancent ou
// reculent d'un jour, d'une semaine ou d'un mois. Tous les états sont listés (colonne État), sans filtre.
// Tableau compact (présentation du tableau du médecin, styles partagés _table-compacte.scss) : Patient (« + » puis le nom
// seul), Sexe / âge, Médecin, Date (« ven. 02/10 »), Heure (« 13:20 », lien « Fixer l'heure » ou « — »), Téléphone
// (règle C9), État (pastille douce), Actions (menu « ⋮ » : Reprogrammer, Marquer honoré / absent dès le jour du
// rendez-vous, Annuler) ; plus d'en-tête de jour. Le reste est dans les détails dépliés sous la ligne.
// RDV-010 : « Générer le bon » en tête du menu d'un rendez-vous planifié du jour (aujourd'hui de la Clinique) : le patient
// arrivé paie son bon de consultation sans passer par le choix de la spécialité et du patient. Mêmes droits que
// « Générer un bon » du tableau de bord (Accueil ; Caisse seulement caisse ouverte). Sans spécialité ou sans patient
// rattaché, l'entrée est grisée avec une info-bulle ; le reste du bon (médecin, paiement) suit ses règles habituelles.
export { PERIODES }

// Entrées du menu « ⋮ » d'un rendez-vous planifié, dans cet ordre (honoré / absent seulement à partir de son jour)
export const ACTIONS_RENDEZ_VOUS = [
    { id: 'reprogrammer', libelle: 'Reprogrammer' },
    { id: 'honore', libelle: 'Marquer honoré' },
    { id: 'absent', libelle: 'Marquer absent' },
    { id: 'annuler', libelle: 'Annuler', danger: true }
]

// RDV-010 : entrée placée avant les autres sur un rendez-vous planifié du jour, pour un utilisateur qui peut générer un bon
export const ACTION_GENERER_BON = { id: 'generer_bon', libelle: 'Générer le bon' }
export const AIDE_SANS_SPECIALITE = 'Spécialité non renseignée : utilisez « Générer un bon »'
export const AIDE_SANS_PATIENT = 'Patient non rattaché à un dossier : utilisez « Générer un bon »'
// Refus au clic : la caisse n'est citée que pour la Caisse (l'Accueil génère un bon sans condition de caisse)
export const REFUS_GENERATION = 'Ce rendez-vous ne permet plus de générer le bon (il n\'est plus planifié aujourd\'hui). Utilisez « Générer un bon ».'
export const REFUS_GENERATION_CAISSE = 'Ce rendez-vous ne permet plus de générer le bon (il n\'est plus planifié aujourd\'hui ou la caisse est fermée). Utilisez « Générer un bon ».'
export const INTROUVABLE_GENERATION = 'Rendez-vous introuvable après actualisation : retrouvez-le dans l\'agenda puis réessayez.'
export const ECHEC_GENERATION = 'Le bon n\'a pas pu être préparé. Réessayez ou utilisez « Générer un bon ».'
// Caisse dont l'ouverture autorise la Caisse à générer un bon (celle que relit le tableau de bord)
export const COMPTE_CAISSE = 1

// Lignes par page : page complète ou carte compacte du tableau de bord (la Clinique plafonne à 100)
export const PAR_PAGE = { page: 50, carte: 20 }

const NAVIGATION = {
    jour: ['Jour précédent', 'Jour suivant'],
    semaine: ['Semaine précédente', 'Semaine suivante'],
    mois: ['Mois précédent', 'Mois suivant']
}

// Info-bulle des boutons de période : le clic revient à la période d'aujourd'hui
const RETOURS = { jour: 'Revenir à aujourd\'hui', semaine: 'Revenir à la semaine en cours', mois: 'Revenir au mois en cours' }

// Recherche : une seule requête par saisie ; carte : rechargement discret chaque minute
export const DELAI_SAISIE = 300
export const ACTUALISATION_CARTE = 60000

export default {
    name: 'agenda-rendez-vous',
    components: { PriseRendezVous, IndicateursRendezVous, FixerHeureRendezVous, MenuActions },
    props: {
        // Carte « Rendez-vous » du tableau de bord : même agenda, sans en-tête de page ni indicateurs du mois
        mode_carte: { type: Boolean, default: false },
        // RDV-010 : carte du tableau de bord — droit de générer un bon calculé par le tableau de bord (même règle que son
        // bouton « Générer un bon ») ; ignoré sur la page /rendez-vous, qui le calcule elle-même
        peut_generer_bon: { type: Boolean, default: false }
    },
    data() {
        return {
            // date : jour d'ancrage choisi ; vide = la période qui contient aujourd'hui (celui de la Clinique)
            periode: 'semaine', date: '', aujourdhui_clinique: '',
            medecin_id: '', recherche: '',
            page: 1, pages: 1, total: 0, lignes: [], echec_chargement: false, ouverts: [],
            annuaire: [],
            is_loading: false, erreur: '', info: '', sequence: 0, detruit: false, search_timer: null, refresh_timer: null,
            en_action: [], annulation: null, motif_annulation: '', erreur_annulation: '', is_saving: false,
            prise_toggler: 0, prise_rendez_vous: null, prise_patient: { id: 0, nom: '' },
            fixer_toggler: 0, fixer_rendez_vous: null,
            indicateurs_toggler: 0,
            // RDV-010 : page /rendez-vous, Caisse — ouverture relue à l'ouverture de la page (1 ouverte ; null inconnue ou
            // en échec : entrée masquée)
            statut_caisse: null
        }
    },

    watch: {
        // RDV-010 : rôle changé sur la page — ouverture de la caisse relue (Caisse)
        role_actif() {
            this.verifier_caisse()
        }
    },

    computed: {
        periodes() {
            return PERIODES
        },

        // RDV-010 : rôle actif (magasin de l'application ; absent hors application)
        role_actif() {
            const store = this.$store
            const role = store && store.getters ? store.getters.activeRole : null
            return role && role.nom ? role.nom : ''
        },

        // RDV-010 : même règle que « Générer un bon » du tableau de bord — Accueil ; Caisse seulement caisse ouverte.
        // Carte : droit transmis par le tableau de bord. Page : ouverture de la caisse relue par la page (la valeur gardée
        // par le navigateur peut dater de la veille) ; Caisse intermittente et autres rôles : jamais.
        generation_bon_autorisee() {
            if (this.mode_carte) return this.peut_generer_bon === true
            if (this.role_actif === 'ROLE_ACCUEIL') return true
            return this.role_actif === 'ROLE_CAISSIERE' && this.statut_caisse === 1
        },

        retours() {
            return RETOURS
        },

        // Jour d'ancrage affiché : celui choisi, sinon aujourd'hui de la Clinique (celui du poste avant la première réponse)
        ancre() {
            return jour_valide(this.date) ? this.date : this.jour_reference()
        },

        plage() {
            return plage_periode(this.periode, this.ancre)
        },

        libelle_plage() {
            return libelle_periode(this.periode, this.ancre)
        },

        libelles_navigation() {
            return NAVIGATION[this.periode] || NAVIGATION.jour
        },

        par_page() {
            return this.mode_carte ? PAR_PAGE.carte : PAR_PAGE.page
        },

        // RDV-005 : mois des indicateurs = mois du premier jour affiché
        mois_indicateurs() {
            return String(this.plage.du || '').substr(0, 7)
        },

        nb_colonnes() {
            return 8
        },

        // « Aucune donnée disponible » : rappel de la période et du médecin
        message_vide() {
            if (this.recherche.trim()) return 'Aucun rendez-vous ne correspond à cette recherche sur cette période.'
            const medecin = this.medecin_id ? this.annuaire.filter(item => String(item.id) === String(this.medecin_id))[0] : null
            let quand = 'sur la ' + this.libelle_plage.charAt(0).toLowerCase() + this.libelle_plage.slice(1)
            if (this.periode === 'jour') quand = 'le ' + jour_lisible(this.ancre)
            if (this.periode === 'mois') quand = 'en ' + mois_lisible(this.ancre).toLowerCase()
            return 'Aucun rendez-vous' + (medecin ? ' pour ' + medecin.nom : '') + ' ' + quand + '.'
        }
    },

    mounted() {
        // La liste visible est prioritaire ; l'annuaire ne sert qu'au filtre médecin.
        // Éviter deux demandes de capacité simultanées au premier affichage.
        this.charger().then(() => this.charger_annuaire(), () => this.charger_annuaire())
        this.verifier_caisse()
        // Carte du tableau de bord : rechargement discret au retour sur la fenêtre et chaque minute, comme la carte du médecin
        if (this.mode_carte) {
            if (typeof window !== 'undefined') window.addEventListener('focus', this.actualiser)
            this.refresh_timer = setInterval(() => {
                if (typeof document === 'undefined' || !document.hidden) this.actualiser()
            }, ACTUALISATION_CARTE)
        }
    },

    beforeDestroy() {
        this.detruit = true
        this.sequence++
        clearTimeout(this.search_timer)
        clearInterval(this.refresh_timer)
        this.search_timer = null
        this.refresh_timer = null
        if (typeof window !== 'undefined') window.removeEventListener('focus', this.actualiser)
    },

    methods: {
        charger_annuaire() {
            return store_rendez_vous.getAcces().then((acces) => {
                if (!this.detruit) this.annuaire = acces && Array.isArray(acces.medecins) ? acces.medecins : []
            }).catch(() => {})
        },

        // Paramètres C8 : période + date d'ancrage ; du / au ne sont plus envoyés (la Clinique calcule la plage). Sans date
        // choisie (période d'aujourd'hui), la date n'est pas envoyée : la Clinique prend son aujourd'hui. Ni « statut » ni
        // « heure_a_fixer » : tous les états sont listés.
        parametres() {
            const data = { periode: this.periode, medecin_id: this.medecin_id ? Number(this.medecin_id) : null, search_item: this.recherche.trim(), page: this.page, per_page: this.par_page }
            if (jour_valide(this.date)) data.date = this.date
            return data
        },

        // discret (true seulement, pas l'événement d'un @click) : rechargement de fond de la carte (fenêtre, minuterie) —
        // sans indicateur de chargement, et un échec garde la liste affichée
        charger(mode) {
            if (this.detruit) return Promise.resolve()
            const discret = mode === true
            clearTimeout(this.search_timer)
            this.search_timer = null
            const sequence = ++this.sequence, parametres = this.parametres()
            if (!discret) {
                this.is_loading = true
                this.erreur = ''
            }
            return store_rendez_vous.getAgenda(parametres).then((result) => {
                if (this.detruit || sequence !== this.sequence) return
                if (!result || !Array.isArray(result.data)) throw new Error('Réponse invalide')
                // Aujourd'hui de la Clinique ; à défaut, la date d'ancrage qu'elle a prise quand aucune n'était demandée
                if (jour_valide(result.aujourdhui)) this.aujourdhui_clinique = result.aujourdhui
                else if (!parametres.date && jour_valide(result.date)) this.aujourdhui_clinique = result.date
                if (discret && this.echec_chargement) this.erreur = ''   // la liste revient après un échec de chargement
                this.echec_chargement = false
                this.lignes = result.data
                this.total = Number(result.total) || 0
                this.pages = Math.max(1, Number(result.last_page) || 1)
                this.ouverts = this.ouverts.filter(id => result.data.some(ligne => ligne.rendez_vous_id === id))
                this.is_loading = false
                // Page devenue vide (dernier rendez-vous de la page annulé ou reprogrammé) : dernière page existante
                if (!result.data.length && this.page > this.pages) {
                    this.page = this.pages
                    return this.charger(discret)
                }
            }).catch((error) => {
                if (this.detruit || sequence !== this.sequence || discret) return
                this.lignes = []
                this.echec_chargement = true
                this.total = 0
                this.is_loading = false
                this.erreur = message_erreur(error, 'Impossible de charger les rendez-vous.')
            })
        },

        relancer() {
            this.page = 1
            return this.charger()
        },

        // Aujourd'hui de la Clinique (réponse de la liste), à défaut celui du poste
        jour_reference() {
            return jour_valide(this.aujourdhui_clinique) ? this.aujourdhui_clinique : aujourdhui()
        },

        // Date d'ancrage d'une période : vide si elle contient aujourd'hui (elle suit alors l'aujourd'hui de la Clinique,
        // même après minuit ou un week-end, tableau de bord resté ouvert), sinon le jour donné
        ancrer(periode, date) {
            const plage = plage_periode(periode, date), reference = this.jour_reference()
            return plage.du <= reference && reference <= plage.au ? '' : date
        },

        // Jour, Semaine ou Mois, même la vue active : période d'aujourd'hui de la Clinique (aucune date envoyée) —
        // aujourd'hui, la semaine en cours ou le mois en cours
        choisir_periode(periode) {
            if (!PERIODES.some(item => item.id === periode)) return Promise.resolve()
            this.periode = periode
            this.date = ''
            return this.relancer()
        },

        // Flèches : jour, semaine ou mois voisin ; revenir sur la période d'aujourd'hui la rattache à aujourd'hui
        deplacer(delta) {
            const date = deplacer_periode(this.periode, this.ancre, delta)
            if (!jour_valide(date)) return Promise.resolve()
            this.date = this.ancrer(this.periode, date)
            return this.relancer()
        },

        chercher() {
            clearTimeout(this.search_timer)
            this.search_timer = setTimeout(() => {
                this.search_timer = null
                this.relancer()
            }, DELAI_SAISIE)
        },

        // Carte : rechargement discret (retour sur la fenêtre, chaque minute), seulement quand rien n'est en cours — ni
        // chargement, ni recherche en attente, ni annulation ou état en cours d'enregistrement
        actualiser() {
            if (this.detruit || this.is_loading || this.search_timer || this.is_saving || this.annulation || this.en_action.length) return Promise.resolve()
            return this.charger(true)
        },

        aller_page(page) {
            if (page >= 1 && page <= this.pages && page !== this.page) {
                this.page = page
                return this.charger()
            }
            return Promise.resolve()
        },

        est_ouvert(id) {
            return this.ouverts.indexOf(id) !== -1
        },

        basculer_details(id) {
            this.ouverts = this.est_ouvert(id) ? this.ouverts.filter(item => item !== id) : this.ouverts.concat([id])
        },

        id_details(ligne) {
            return 'agenda-details-' + this._uid + '-' + ligne.rendez_vous_id
        },

        // Détails dépliés sous la ligne : dossier, spécialité, motif, rappel (état et dernier appel), qui l'a donné et
        // quand ; puis, s'ils sont renseignés : commentaire, heure fixée par, état clos ou passé, arrivée en caisse, motif
        // d'annulation. Médecin, date, heure et téléphone sont dans les colonnes.
        details(ligne) {
            const vide = valeur => valeur === null || valeur === undefined || String(valeur).trim() === ''
            const cree_le = jour_instant(ligne.created_at), fixee_le = jour_instant(ligne.heure_fixee_at), etat_le = jour_instant(ligne.statut_at), appel = instant_lisible(ligne.dernier_rappel_at)
            const donne = (ligne.source === 'accueil' ? 'À l\'accueil' : 'En consultation') + (ligne.cree_par_nom ? ' par ' + ligne.cree_par_nom : '') + (cree_le ? ' le ' + cree_le : '')
            const rappel = (ligne.rappel_libelle || '') + (appel ? ' · dernier appel le ' + appel : '')
            const heure_fixee = !est_heure_a_fixer(ligne) && ligne.heure_fixee_par_nom ? ligne.heure_fixee_par_nom + (fixee_le ? ' le ' + fixee_le : '') : ''
            let etat = ''
            if (ligne.statut !== 'planifie' && (ligne.statut_par_nom || etat_le)) etat = (ligne.statut_libelle || '') + (ligne.statut_par_nom ? ' par ' + ligne.statut_par_nom : '') + (etat_le ? ' le ' + etat_le : '')
            else if (ligne.statut === 'planifie' && ligne.passe) etat = 'Passé, non renseigné'
            const toujours = [['N° dossier', ligne.dossier], ['Spécialité', ligne.type_consultation], ['Motif', ligne.motif], ['Rappel', rappel], ['Donné', donne]]
            const si_renseigne = [['Commentaire', ligne.commentaire], ['Heure fixée par', heure_fixee], ['État', etat], ['Arrivée en caisse', this.arrivee(ligne).replace('Arrivé en caisse à ', '')], ['Motif d\'annulation', ligne.annulation_motif]]
            return toujours.map(detail => [detail[0], vide(detail[1]) ? '—' : String(detail[1]).trim()]).concat(si_renseigne.filter(detail => !vide(detail[1])))
        },

        occupee(ligne) {
            return this.en_action.indexOf(ligne.rendez_vous_id) !== -1
        },

        // Honoré / absent : au plus tôt le jour du rendez-vous, dans le fuseau de la clinique (la Clinique le vérifie aussi)
        peut_marquer(ligne) {
            const jour = jour_rdv(ligne)
            return ligne.statut === 'planifie' && !!jour && jour <= this.jour_reference()
        },

        marquer(ligne, statut) {
            if (this.occupee(ligne) || !this.peut_marquer(ligne)) return Promise.resolve()
            this.en_action = this.en_action.concat([ligne.rendez_vous_id])
            this.erreur = ''
            return store_rendez_vous.changerStatut(ligne.rendez_vous_id, { statut: statut }).then((response) => {
                if (this.detruit) return
                if (!response || response.success !== true) throw new Error('Refus')
                this.info = response.message || 'État enregistré.'
                this.indicateurs_toggler++
            }).catch((error) => {
                if (this.detruit) return
                this.erreur = message_erreur(error, 'L\'état n\'a pas été enregistré. Actualisez puis réessayez.')
            }).then(() => {
                if (this.detruit) return
                this.en_action = this.en_action.filter(id => id !== ligne.rendez_vous_id)
                const refus = this.erreur
                return this.charger().then(() => { if (refus && !this.erreur && !this.detruit) this.erreur = refus })
            })
        },

        ouvrir_annulation(ligne) {
            this.annulation = ligne
            this.motif_annulation = ''
            this.erreur_annulation = ''
        },

        confirmer_annulation() {
            if (this.is_saving || !this.annulation) return Promise.resolve()
            if (!this.motif_annulation.trim()) {
                this.erreur_annulation = 'Indiquez le motif de l\'annulation.'
                return Promise.resolve()
            }
            this.is_saving = true
            this.erreur_annulation = ''
            return store_rendez_vous.changerStatut(this.annulation.rendez_vous_id, { statut: 'annule', motif: this.motif_annulation.trim() }).then((response) => {
                if (this.detruit) return
                if (!response || response.success !== true) throw new Error('Refus')
                this.is_saving = false
                this.annulation = null
                this.info = response.message || 'Rendez-vous annulé.'
                this.indicateurs_toggler++
                return this.charger()
            }).catch((error) => {
                if (this.detruit) return
                this.is_saving = false
                this.erreur_annulation = message_erreur(error, 'L\'annulation n\'a pas été enregistrée. Actualisez puis réessayez.')
            })
        },

        // « Prendre un rendez-vous » : fenêtre de prise sans patient désigné, l'Accueil le recherche d'abord
        prendre_rendez_vous() {
            this.prise_patient = { id: 0, nom: '' }
            this.prise_rendez_vous = null
            this.info = ''
            this.prise_toggler = (this.prise_toggler === 0) ? 1 : 0
        },

        reprogrammer(ligne) {
            this.prise_patient = { id: ligne.patient_id ? Number(ligne.patient_id) : 0, nom: ligne.patient_nom || '' }
            this.prise_rendez_vous = ligne
            this.info = ''
            this.prise_toggler = (this.prise_toggler === 0) ? 1 : 0
        },

        // Rendez-vous pris ou reprogrammé (fenêtre fermée après l'enregistrement)
        apres_prise(resultat) {
            this.info = resultat && resultat.message ? resultat.message : (this.prise_rendez_vous ? 'Rendez-vous reprogrammé.' : 'Rendez-vous enregistré.')
            this.indicateurs_toggler++
            return this.charger()
        },

        // Colonne Date : « ven. 02/10 », l'année seulement hors de l'année en cours (aujourd'hui de la Clinique)
        date_courte(ligne) {
            return jour_abrege(jour_rdv(ligne), this.jour_reference())
        },

        // Colonne Heure : « 13:20 » ; un rendez-vous sans heure affiche le lien « Fixer l'heure » tant que c'est possible
        // (gabarit), sinon « — » — jamais 00:00
        heure(ligne) {
            if (est_heure_a_fixer(ligne)) return '—'
            return heure_lisible(ligne.date_rdv_locale)
        },

        // C9 : téléphone du patient, sinon celui de l'accompagnant avec la filiation (« +22890246578 (Mère) »), sinon « — »
        telephone(ligne) {
            return telephone_affiche(ligne, 'telephone')
        },

        titre_telephone(ligne) {
            return titre_telephone(ligne, 'telephone')
        },

        ton(ligne) {
            return ton_statut(ligne.statut)
        },

        // Menu « ⋮ » : rendez-vous planifié seulement ; « Générer le bon » en tête le jour même (RDV-010) ; « Marquer
        // honoré » et « Marquer absent » à partir de son jour
        actions(ligne) {
            if (!ligne || ligne.statut !== 'planifie') return []
            const marquer = this.peut_marquer(ligne), bon = this.action_bon(ligne)
            const liste = ACTIONS_RENDEZ_VOUS.filter(action => marquer || (action.id !== 'honore' && action.id !== 'absent'))
            return bon ? [bon].concat(liste) : liste
        },

        // Entrée proposée et active seulement (une entrée grisée n'est jamais exécutée)
        agir(ligne, action) {
            const item = this.actions(ligne).filter(entree => entree.id === action)[0]
            if (this.occupee(ligne) || !item || item.disabled) return Promise.resolve()
            if (action === 'generer_bon') return this.generer_bon(ligne)
            if (action === 'honore' || action === 'absent') return this.marquer(ligne, action)
            if (action === 'reprogrammer') this.reprogrammer(ligne)
            else this.ouvrir_annulation(ligne)
            return Promise.resolve()
        },

        // RDV-010 : rendez-vous planifié dont le jour est aujourd'hui de la Clinique (jamais la date du poste). Un
        // rendez-vous en retard (« passé » dans la journée) reste concerné : la Clinique l'honore toute la journée.
        bon_du_jour(ligne) {
            return !!ligne && ligne.statut === 'planifie' && jour_valide(this.aujourdhui_clinique) && jour_rdv(ligne) === this.aujourdhui_clinique
        },

        // RDV-010 : entrée « Générer le bon » de la ligne, grisée sans patient rattaché ou sans spécialité ; null sinon
        action_bon(ligne) {
            if (!this.generation_bon_autorisee || !this.bon_du_jour(ligne)) return null
            if (!(Number(ligne.patient_id) > 0)) return Object.assign({}, ACTION_GENERER_BON, { disabled: true, aide: AIDE_SANS_PATIENT })
            if (!(Number(ligne.type_consultation_id) > 0)) return Object.assign({}, ACTION_GENERER_BON, { disabled: true, aide: AIDE_SANS_SPECIALITE })
            return Object.assign({}, ACTION_GENERER_BON)
        },

        // RDV-010 : page /rendez-vous, Caisse — ouverture de la caisse relue (celle du tableau de bord) ; la carte suit le
        // droit transmis par le tableau de bord
        verifier_caisse() {
            const store = this.$store
            if (this.mode_carte || this.role_actif !== 'ROLE_CAISSIERE' || !store || typeof store.dispatch !== 'function') return Promise.resolve()
            return Promise.resolve(store.dispatch('getStatutOuvertureCaisse', COMPTE_CAISSE)).then((statut) => {
                if (!this.detruit) this.statut_caisse = statut === 1 ? 1 : 0
            }).catch(() => {
                if (!this.detruit) this.statut_caisse = null
            })
        },

        // RDV-010 : refus au clic — la caisse n'est citée que pour la Caisse
        refus_generation() {
            return this.role_actif === 'ROLE_CAISSIERE' ? REFUS_GENERATION_CAISSE : REFUS_GENERATION
        },

        // RDV-010 : rendez-vous relu parmi ceux du patient (à venir ; passés, où est un retard du jour), null s'il n'y est
        // pas — quand il a quitté la page rechargée (rendez-vous ajouté ou déplacé plus tôt dans la période)
        retrouver_rendez_vous(ligne) {
            const id = ligne.rendez_vous_id
            return Promise.resolve(store_rendez_vous.getProchainPatient(ligne.patient_id)).then((reponse) => {
                if (!reponse || !reponse.success || !reponse.data) throw new Error('Réponse invalide')
                const liste = reponse.data
                const lignes = (Array.isArray(liste.a_venir) ? liste.a_venir : []).concat(Array.isArray(liste.passes) ? liste.passes : [])
                return lignes.filter(item => item && item.rendez_vous_id === id)[0] || null
            })
        },

        // RDV-010 : « Générer le bon ». La liste est d'abord rechargée (aujourd'hui de la Clinique, état du rendez-vous,
        // ouverture de la caisse sur la page) ; une ligne sortie de la page est relue parmi les rendez-vous du patient ;
        // si elle ne s'y prête plus, message et aucun bon.
        generer_bon(ligne) {
            const depart = this.action_bon(ligne)
            if (this.occupee(ligne) || !depart || depart.disabled) return Promise.resolve()
            const id = ligne.rendez_vous_id
            this.en_action = this.en_action.concat([id])
            this.info = ''
            return Promise.all([this.charger(), this.verifier_caisse()]).then(() => {
                // Liste en échec : son message reste, aucun bon
                if (this.detruit || this.echec_chargement) return null
                const actuelle = this.lignes.filter(item => item.rendez_vous_id === id)[0]
                if (actuelle || !this.generation_bon_autorisee) return { ligne: actuelle || null, relue: false }
                return this.retrouver_rendez_vous(ligne).then(trouvee => ({ ligne: trouvee, relue: true }))
            }).then((suite) => {
                if (!suite || this.detruit) return
                const action = suite.ligne ? this.action_bon(suite.ligne) : null
                if (action && !action.disabled) {
                    this.ouvrir_bon(suite.ligne)
                    return
                }
                if (!this.erreur) this.erreur = suite.relue && !suite.ligne ? INTROUVABLE_GENERATION : this.refus_generation()
            }).catch(() => {
                if (!this.detruit) this.erreur = ECHEC_GENERATION
            }).then(() => {
                if (!this.detruit) this.en_action = this.en_action.filter(item => item !== id)
            })
        },

        // Même état que le parcours normal : remises à zéro du tableau de bord (bon préparé, facture, paiement en cours,
        // jamais repris), spécialité puis patient choisis (liste des patients vidée comme au choix du patient), puis le bon.
        // Le contexte du rendez-vous passe par la route (propriété « rendez_vous » du bon) : rien n'est gardé pour un
        // prochain bon.
        ouvrir_bon(ligne) {
            const store = this.$store
            const remises = [['SET_PAYING_BILL_STATE', ''], ['SET_BILL_SELECTED_OPERATIONS', []], ['SET_IS_PAID', false], ['SET_IS_PRE_SAVED_BON', false],
                ['SET_SELECTED_BON_CONSOMMABLES', []], ['SET_SELECTED_BON_ID', null], ['SET_MEDECIN_BON_PREPARE', null], ['SET_PAYMENT_ACTION', '']]
            remises.forEach(remise => store.commit(remise[0], remise[1]))
            store.commit('SET_TYPE_ACTION_SELECTED', 'bon_consultation')
            store.commit('SET_TYPE_CONS_SELECTED', type_bon_rendez_vous(ligne))
            store.commit('SET_PATIENT', {})
            store.commit('SET_CHOSEN_PATIENT', patient_bon_rendez_vous(ligne))
            const navigation = this.$router.push({ name: 'Bon consultation', params: { rendez_vous: contexte_bon_rendez_vous(ligne) } })
            if (navigation && typeof navigation.catch === 'function') navigation.catch(() => {})
        },

        date_rdv(ligne) {
            return date_rdv_lisible(ligne)
        },

        // Rendez-vous planifié sans heure dont le jour n'est pas passé (un jour passé : Honoré, Absent ou Reprogrammer) ;
        // la Clinique vérifie le rôle (action « prendre »)
        peut_fixer_heure(ligne) {
            return heure_a_fixer_possible(ligne)
        },

        ouvrir_fixer_heure(ligne) {
            if (!this.peut_fixer_heure(ligne) || this.occupee(ligne)) return
            this.fixer_rendez_vous = ligne
            this.info = ''
            this.fixer_toggler = (this.fixer_toggler === 0) ? 1 : 0
        },

        apres_fixation(rendez_vous, reponse) {
            this.info = reponse && reponse.message ? reponse.message : 'Heure fixée.'
            this.indicateurs_toggler++
            return this.charger()
        },

        // RDV-005 : arrivée mesurée à la validation du bon en caisse (heure de l'établissement)
        arrivee(ligne) {
            if (!ligne || ligne.statut !== 'honore' || !ligne.arrivee_locale) return ''
            const retard = Number(ligne.retard_minutes)
            return 'Arrivé en caisse à ' + heure_lisible(ligne.arrivee_locale) + (retard > 0 ? ' (+' + retard + ' min)' : '')
        }
    }
}
